/**
 * Detect PocketBase password-recovery deep links.
 * PB emails use `{APP_URL}/_/#/auth/confirm-password-reset/{TOKEN}`
 * or `#/auth/confirm-password-reset/{TOKEN}`.
 */

const PB_RESET_RE = /\/auth\/confirm-password-reset\/([^/?#]+)/i;

export function pocketBaseResetTokenFromHash(
  hash = typeof window !== 'undefined' ? window.location.hash : '',
): string | null {
  const raw = hash.startsWith('#') ? hash.slice(1) : hash;
  const m = PB_RESET_RE.exec(raw);
  return m?.[1] ? decodeURIComponent(m[1]) : null;
}

export function pocketBaseResetTokenFromSearch(
  search = typeof window !== 'undefined' ? window.location.search : '',
): string | null {
  const params = new URLSearchParams(
    search.startsWith('?') ? search.slice(1) : search,
  );
  const token = params.get('token') || params.get('reset');
  return token?.trim() || null;
}

/** Clear recovery hash/query without a full reload. */
export function clearAuthRecoveryFromUrl(): void {
  if (typeof window === 'undefined') return;
  const url = new URL(window.location.href);
  url.searchParams.delete('token');
  url.searchParams.delete('reset');
  url.hash = '';
  const path =
    url.pathname.startsWith('/_/') || url.pathname === '/_/'
      ? '/login'
      : url.pathname || '/login';
  window.history.replaceState({}, '', `${path}${url.search}`);
}
